<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/anotefromjeansasson"><span class="element-title-text">A Note From Jean Sasson</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-prologue has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/prologue"><span class="element-title-text">Prologue</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/chapterone"><span class="element-title-text">Chapter One</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chaptertwo" title="Link target outside of Sample"><span class="element-title-text">Chapter Two</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapterthree" title="Link target outside of Sample"><span class="element-title-text">Chapter Three</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapterfour" title="Link target outside of Sample"><span class="element-title-text">Chapter Four</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapterfive" title="Link target outside of Sample"><span class="element-title-text">Chapter Five</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chaptersix" title="Link target outside of Sample"><span class="element-title-text">Chapter Six</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapterseven" title="Link target outside of Sample"><span class="element-title-text">Chapter Seven</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chaptereight" title="Link target outside of Sample"><span class="element-title-text">Chapter Eight</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapternine" title="Link target outside of Sample"><span class="element-title-text">Chapter Nine</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chapterten" title="Link target outside of Sample"><span class="element-title-text">Chapter Ten</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chaptereleven" title="Link target outside of Sample"><span class="element-title-text">Chapter Eleven</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/chaptertwelve" title="Link target outside of Sample"><span class="element-title-text">Chapter Twelve</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="element-title-text">Epilogue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/allaboutjeansasson" title="Link target outside of Sample"><span class="element-title-text">All About Jean Sasson</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/excerptfromprincesssultanascircle" title="Link target outside of Sample"><span class="element-title-text">Excerpt from Princess Sultana’s Circle</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?648e9b10